import { render, staticRenderFns } from "./FilterDropdown.vue?vue&type=template&id=a91f518c&"
import script from "./FilterDropdown.vue?vue&type=script&lang=ts&"
export * from "./FilterDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QOptionGroup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QOptionGroup})
